import { EventCatalogFromKeys, EventType } from "../../../types";

export const TrendsEventKeys = {
  ADMIN_TRENDS_PAGE_VIEW: "admin-trends-page-view",
  ADMIN_TRENDS_PAGE_VIEW_ORGANIZATION_REQUIRED:
    "admin-trends-page-view-organization-required",
  ADMIN_TRENDS_TAB_CHANGE: "admin-trends-tab-change",
  TRENDS_CLIENT_CHART_INTERACTION: "trends-client-chart-interaction",
  TRENDS_CLIENT_CHART_TYPE_CHANGE: "trends-client-chart-type-change",
  TRENDS_CLIENT_EXPORT: "trends-client-export",
  TRENDS_CLIENT_REFRESH: "trends-client-refresh",
  TRENDS_CLIENT_REPORT_TYPE_CHANGE: "trends-client-report-type-change",
  TRENDS_CLIENT_TIME_PERIOD_CHANGE: "trends-client-time-period-change",
  TRENDS_CLIENT_YEAR_CHANGE: "trends-client-year-change",
} as const;

export const TrendsEventCatalog: EventCatalogFromKeys<typeof TrendsEventKeys> =
  {
    [TrendsEventKeys.ADMIN_TRENDS_PAGE_VIEW]: {
      description: "Admin viewed the trends page",
      eventType: EventType.PAGE_VIEW,
      id: TrendsEventKeys.ADMIN_TRENDS_PAGE_VIEW,
    },
    [TrendsEventKeys.ADMIN_TRENDS_PAGE_VIEW_ORGANIZATION_REQUIRED]: {
      description: "Admin viewed the trends page but organization is required",
      eventType: EventType.PAGE_VIEW,
      id: TrendsEventKeys.ADMIN_TRENDS_PAGE_VIEW_ORGANIZATION_REQUIRED,
    },
    [TrendsEventKeys.ADMIN_TRENDS_TAB_CHANGE]: {
      description: "Admin changed tab in trends report tabs",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.ADMIN_TRENDS_TAB_CHANGE,
    },
    [TrendsEventKeys.TRENDS_CLIENT_CHART_INTERACTION]: {
      description: "User interacted with the trends chart in TrendsClient",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.TRENDS_CLIENT_CHART_INTERACTION,
    },
    [TrendsEventKeys.TRENDS_CLIENT_CHART_TYPE_CHANGE]: {
      description: "User changed chart type in TrendsClient",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.TRENDS_CLIENT_CHART_TYPE_CHANGE,
    },
    [TrendsEventKeys.TRENDS_CLIENT_EXPORT]: {
      description: "User exported data in TrendsClient",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.TRENDS_CLIENT_EXPORT,
    },
    [TrendsEventKeys.TRENDS_CLIENT_REFRESH]: {
      description: "User refreshed data in TrendsClient",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.TRENDS_CLIENT_REFRESH,
    },
    [TrendsEventKeys.TRENDS_CLIENT_REPORT_TYPE_CHANGE]: {
      description: "User changed report type in TrendsClient",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.TRENDS_CLIENT_REPORT_TYPE_CHANGE,
    },
    [TrendsEventKeys.TRENDS_CLIENT_TIME_PERIOD_CHANGE]: {
      description: "User changed the time period in TrendsClient",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.TRENDS_CLIENT_TIME_PERIOD_CHANGE,
    },
    [TrendsEventKeys.TRENDS_CLIENT_YEAR_CHANGE]: {
      description: "User changed the year in TrendsClient",
      eventType: EventType.INTERACTION,
      id: TrendsEventKeys.TRENDS_CLIENT_YEAR_CHANGE,
    },
  };
